import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, DatePicker, Select } from 'components';
import { Globals, checkPermission, Constants } from 'utils';
import { QuoteTypeService } from 'services';
import { CleanIcon, TrashWhiteIcon, AddWhiteIcon, ConfirmIcon, StarIcon, EditIcon, TrashIcon, ChangeStatusIcon } from 'assets/icons';
import CreateQuoteType from './create-quote-type';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	status: ''
}

class QuoteTypes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Recomendación',
			'Estatus',
			'Acciones'
		],
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Tipos de cita',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await QuoteTypeService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.quote_types.rows,
			last_page: res.quote_types.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el tipo de cita?',async () => {
			await QuoteTypeService.admin.delete({
				quote_type_id: item?.id
			});
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	changeStatus = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm(`¿Desea ${ item?.status == Constants.QUOTE_TYPES_STATUS.ACTIVE ? 'desactivar' : 'activar' } el tipo de cita?`,async () => {
			await QuoteTypeService.admin.changeStatus({
				quote_type_id: item.id
			});
			this.load(true);
		});
	}	
	
	render() {
		const { visible } = this.state;
		const item: any = this.state.item;

		return (
			<div id="quote-types">
				<BackComponent />

				<div className={ `container-modal-right ${ visible ? 'active' : '' }` }>
					{
						visible && (
							<CreateQuoteType
								item={ this.state.item }
								title={ `${ this.state.item ? 'Editar' : 'Nuevo' } tipo de cita` }
								onClose={ () => this.onClose() }
							/>
						)
					}
				</div>

				<div className="row row-filter">
					<div className="col-md-9">
						<div className="row">
							<div className="col-md-4">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-4">
								<Select
									placeholder="Estatus"
									name="status"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.QUOTE_TYPES_STATUS.ACTIVE.toString(), label: 'Activos' },
										{ value: Constants.QUOTE_TYPES_STATUS.INACTIVE.toString(), label: 'Inactivos' }
									] } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-3 text-right">
						{
							checkPermission(Constants.MODULES.QUOTE_TYPES,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header } rightAlign={[3]}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td>{ i.recommendation || '-' }</td>
								<td>{ i.status_text || '-' }</td>
								<td className="text-right">
									{
										checkPermission(Constants.MODULES.QUOTE_TYPES,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.QUOTE_TYPES,'write') && (
											<Tooltip title={ i.status == Constants.QUOTE_TYPES_STATUS.ACTIVE ? 'Desactivar' : 'Activar' }>
												<a className="link-icon" href="#" onClick={ (e: any) => this.changeStatus(e,i) }>
													<img src={ ChangeStatusIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.QUOTE_TYPES,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>		
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(QuoteTypes);